import { render, staticRenderFns } from "./DeleteTaskButton.vue?vue&type=template&id=02332744&"
import script from "./DeleteTaskButton.vue?vue&type=script&lang=js&"
export * from "./DeleteTaskButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports